const gtmLoginClicked = () => {
    dataLayer.push({
        event: 'login',
        step: 'submit',
        _clear: true,
    })
}

export default gtmLoginClicked
